import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/ak-logo-color.png'


const _withScopeId = n => (_pushScopeId("data-v-4db66462"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav-wrap" }
const _hoisted_2 = { class: "navbars" }
const _hoisted_3 = { class: "col brand" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0,
  alt: "AKMRO"
}, null, -1))
const _hoisted_5 = { class: "col nav" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link",
  href: "/aircrafts"
}, "Aircrafts", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link",
  href: "/pricing"
}, "Pricing", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link",
  href: "/contact"
}, "Contact Us", -1))
const _hoisted_9 = { class: "col account" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pad" }, " ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "SignUp", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { key: 2 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "LOGOUT", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "LOGIN", -1))
const _hoisted_17 = [
  _hoisted_16
]

import { get as _get } from "lodash";
import { ref, computed } from "vue";
import { useStore } from "@/store";
import router from "@/router";

import AboutModal from "@/components/AboutModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MainNavbar',
  setup(__props) {

const store = useStore();

const aboutModalVisible = ref(false);

const userName = computed(() => {
  const user = store.user;
  if (user === null) return "";

  return user.displayName || user.email || "anonymous";
});

const isLogin = computed(() => {
  return store.user !== null;
});

function login() {
  router.push("/signin");
}

function signup() {
  router.push("/signup");
}

function logout() {
  router.push("/signout");
}

function editProfile() {
  router.push("/editprofile");
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(AboutModal, {
      visible: aboutModalVisible.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (aboutModalVisible.value = false))
    }, null, 8, ["visible"]),
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createElementVNode("section", _hoisted_5, [
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("a", {
          class: "nav-link",
          href: "#",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (aboutModalVisible.value = true))
        }, "About")
      ]),
      _createElementVNode("section", _hoisted_9, [
        _hoisted_10,
        (!isLogin.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "btn nav-btn btn-signup",
              onClick: signup
            }, _hoisted_12))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "btn nav-btn btn-user",
              onClick: editProfile
            }, [
              _createElementVNode("span", null, _toDisplayString(userName.value), 1)
            ])),
        (isLogin.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("button", {
                class: "btn nav-btn btn-signout",
                onClick: logout
              }, _hoisted_15)
            ]))
          : (_openBlock(), _createElementBlock("button", {
              key: 3,
              class: "btn nav-btn btn-signin",
              onClick: login
            }, _hoisted_17))
      ])
    ])
  ]))
}
}

})